var map = {
	"./image-amyrobson.png": 695,
	"./image-amyrobson.webp": 594,
	"./image-juliusomo.png": 40,
	"./image-juliusomo.webp": 1,
	"./image-maxblagun.png": 353,
	"./image-maxblagun.webp": 70,
	"./image-ramsesmiron.png": 754,
	"./image-ramsesmiron.webp": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 283;